import { RecoilState, atom } from "recoil";
import { Clip } from "MVVM/Types/clip";
import { IClip } from "MVVM/@types";

type TPinnedClipWithError = {
  clipId: string;
  errorMessage: string;
};

type TNullableClip = IClip | null;

export const PinnedClipWithError: RecoilState<TPinnedClipWithError> = atom({
  key: "PinnedClipWithError_V0.1",
  default: {
    clipId: "",
    errorMessage: "",
  },
});

export const PinnedClipsAtom: RecoilState<Clip[]> = atom({
  key: "PinnedClip_V0.1",
  default: [] as Clip[],
});

export const ViewableClip: RecoilState<TNullableClip> = atom({
  key: "ViewableClip_V0.1",
  default: null as TNullableClip,
});

export const ViewableClipLoading: RecoilState<boolean> = atom({
  key: "ViewableClipLoading_V0.1",
  default: false,
});

export const LoadingClipId: RecoilState<string | null> = atom({
  key: "LoadingClipId_V0.1",
  default: null as string | null,
});
